import React from 'react';

import { Alert, Collapse } from 'antd';

import { AlertMessage } from 'hooks/alertMessage/useAlertMessage';

import './ActionCommon.less';

interface CollapsableContainerProps {
  title: string;
  alertMessage?: AlertMessage;
  children: React.ReactNode;
}

export function CollapsableContainer({
  title,
  alertMessage,
  children,
}: CollapsableContainerProps) {
  return (
    <Collapse>
      <Collapse.Panel header={title} key="1">
        <div className={'collapse-content'}>
          <div className={'collapse-content-actions'}>{children}</div>
          {alertMessage && (
            <Alert
              message={alertMessage.message}
              type={alertMessage.type}
              showIcon
            />
          )}
        </div>
      </Collapse.Panel>
    </Collapse>
  );
}
